import {
  Component,
  computed,
  ElementRef,
  HostListener,
  inject,
  Input,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { IncidentsModel } from '../../models/incident.models';
import { ParamsModel } from '../../models/params.model';
import { MatchDataService } from '../../services/match-data.service';
import { environment } from '../../../../../environments/environment';
import { ScoresSportsService } from '../../../../services/scores-sports.service';
import { CommonModule } from '@angular/common';
import { NzSkeletonComponent } from 'ng-zorro-antd/skeleton';
import { NzCardComponent } from 'ng-zorro-antd/card';
import { InfoMatchComponent } from './info-match/info-match.component';
import { IncidentsComponent } from './incidents/incidents.component';
import { TranslateModule } from '@ngx-translate/core';
import { NoResultComponent } from '../../../../components/shared/no-result/no-result.component';
import { ThemeService } from '@/app/services/theme.service';

@Component({
  selector: 'app-summary-football',
  standalone: true,
  imports: [
    CommonModule,
    NzSkeletonComponent,
    NzCardComponent,
    InfoMatchComponent,
    IncidentsComponent,
    TranslateModule,
    NoResultComponent,
  ],
  templateUrl: './summary-football.component.html',
  styleUrl: './summary-football.component.scss',
})
export class SummaryFootballComponent {
  isTrackerHidden: boolean = false;

  @ViewChild('mainTracker') mainTracker!: ElementRef;

  incidentsFirstHalf: Array<IncidentsModel> = [];
  incidentsSecondHalf: Array<IncidentsModel> = [];
  incidentsOvertime: Array<IncidentsModel> = [];
  incidentsPenaltys: Array<IncidentsModel> = [];
  infoMatch: any;
  loading = true;
  viewLiveTracker: boolean = false;
  linkLiveTracker: SafeResourceUrl = '';

  urlIMG = environment.urlIMG;

  competition: any;
  competitionLogo: any;
  nameStage: any;

  @Input() set infoMatchSelected(infoMatchSelected: any) {
    this.incidentsFirstHalf = infoMatchSelected.incidentsFirstHalf;
    this.incidentsSecondHalf = infoMatchSelected.incidentsSecondHalf;
    this.incidentsOvertime = infoMatchSelected.incidentsOvertime;
    this.incidentsPenaltys = infoMatchSelected.incidentsPenaltys;
    this.infoMatch = {
      homeTeam: infoMatchSelected.homeTeam.name,
      awayTeam: infoMatchSelected.awayTeam.name,
      statusHalf: infoMatchSelected.score.status,
      referee: infoMatchSelected.referee || null,
      venue: infoMatchSelected.venue || null,
      environment: infoMatchSelected.environment || null,
      competitionYouTube: infoMatchSelected.competitionYouTube || null,
      urlYoutubeImg: infoMatchSelected.thumbnail || null,
    };
  }

  @Input() params: ParamsModel = {} as ParamsModel;

  private themeService = inject(ThemeService);

  getYoutubeLogo = computed(() => {
    const isDarkMode = this.themeService.currentTheme() === 'dark';

    return `${environment.urlIMG}youtube-logo${isDarkMode ? '-dark' : ''}.png`;
  });

  constructor(
    private readonly matchService: MatchDataService,
    private sanitizer: DomSanitizer,
    private scoreService: ScoresSportsService
  ) {}

  ngOnInit(): void {
    this.getLinkTracker();
    this.viewLiveTracker =
      this.infoMatch &&
      this.infoMatch.statusHalf.code > 1 &&
      this.infoMatch.statusHalf.code < 8;
    this.getCompetitionById(this.params.idCompetition);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      this.viewLiveTracker &&
      (this.infoMatch.statusHalf.code <= 1 ||
        this.infoMatch.statusHalf.code >= 8)
    ) {
      this.viewLiveTracker = false;
    }
  }

  getCompetitionById(id: any) {
    this.scoreService.getCompetitionById(id).subscribe((response: any) => {
      if (response.status) {
        this.competition = response.competition.name;
        this.competitionLogo = response.competition.logo;
        this.nameStage = response.competition.nameStage;
        this.loading = false;
      }
    });
  }

  private getLinkTracker() {
    this.linkLiveTracker = this.sanitizer.bypassSecurityTrustResourceUrl(
      this.matchService.getUrlMatchTracker(this.params)
    );
  }

  goToLink(url: string) {
    window.open(url, '_blank');
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (this.mainTracker) {
      const trackerPosition =
        this.mainTracker.nativeElement.getBoundingClientRect();
      this.isTrackerHidden =
        trackerPosition.bottom < 0 || trackerPosition.top > window.innerHeight;
    }
  }
}
